import { render, staticRenderFns } from "./TukkiPage.vue?vue&type=template&id=2444aaf0&scoped=true"
import script from "./TukkiPage.vue?vue&type=script&lang=js"
export * from "./TukkiPage.vue?vue&type=script&lang=js"
import style0 from "./TukkiPage.vue?vue&type=style&index=0&id=2444aaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444aaf0",
  null
  
)

export default component.exports